import * as technicianGroups from './technicianGroups';
import * as technician from './technician';

const reducers = {
  ...technicianGroups,
  ...technician,
};

export default reducers;
